import { Navigate, Route, Routes } from 'react-router-dom';
import { AccountsWithDashboard } from './AccountsWithDashboard';
import { useAuth } from '../../AuthContext';
import { AddAccount } from './AddAccount';
import { ManageSpecificAccountRoutes } from './ManageSpecificAccountRoutes';
import { ManageSpecificAccountUserRoutes } from './ManageSpecificAccountUserRoutes';
import { ManageCropRoutes } from './ManageCropRoutes';
import { AddUser } from './AddUser';
import { UsersWithDashboard } from './UsersWithDashboard';

export function ManageAccountsRoutes() {
    const {
        currentUser
    } = useAuth();

    if (!(currentUser.is_agency_admin || currentUser.is_super_super_user)) {
        return <Navigate to="/" />
    }

    return <>
        <Routes>
            {/* /management/accounts */}
            <Route path="accounts" element={<Navigate to="/management/accounts/list" replace />} />
            <Route path="accounts/list" element={
                <AccountsWithDashboard viewType="list" />
            } />
            <Route path="accounts/dashboard" element={
                <AccountsWithDashboard viewType="dashboard" />
            } />
            <Route path="accounts/:accountUniqueId/*" element={
                <ManageSpecificAccountRoutes />
            } />
            <Route path="add-account" element={
                <AddAccount />
            } />
            {/* /management/users */}
            <Route path="users" element={<Navigate to="/management/users/list" replace />} />
            <Route path="users/list" element={
                <UsersWithDashboard viewType="list" />
            } />
            <Route path="users/dashboard" element={
                <UsersWithDashboard viewType="dashboard" />
            } />
            <Route path="users/:userUniqueId/*" element={
                <ManageSpecificAccountUserRoutes />
            } />
            <Route path="add-user" element={
                <AddUser />
            } />
            <Route path="crops/:cropUniqueId/*" element={
                <ManageCropRoutes />
            } />
            <Route
                path="*"
                element={<Navigate
                    to={`/management/accounts`}
                    replace
                />}
            />
        </Routes>
    </>
}